import * as React from 'react';
import {usePopperTooltip} from 'react-popper-tooltip';
import 'react-popper-tooltip/dist/styles.css';
import {Fragment} from "react";

import './TooltipIcon.scss' ;
import {Link} from "react-router-dom";

const TooltipIcon = ({containerClassName='tooltip-container', arrowClassName='tooltip-arrow', component, ...props}) =>
{
    const defaultStyle = {
        marginLeft: '6px',
        marginRight: '6px',
        ...props.style
    }

    const {
        getArrowProps,
        getTooltipProps,
        setTooltipRef,
        setTriggerRef,
        visible

    } = usePopperTooltip({placement: props.placement === undefined ? 'top' : props.placement, followCursor: true, offset: [0, 8], /*delayHide: 100000 */}, {});

    const renderComponent = () =>
    {

        if (props.link !== undefined)
        {
            if (component !== undefined)
            {
                const IconWrapper = component;

                const divStyle = {...defaultStyle, display: 'inline-block', cursor: 'pointer'};

                return <Link to={props.link} target={props.target}><div ref={setTriggerRef} style={divStyle} ><IconWrapper color={props.color}/></div></Link>
            }
            else
            {

                return <Link to={props.link}>
                <span ref={setTriggerRef} style={{...defaultStyle, ...props.style, cursor: 'pointer', color: props.color}}
                      className={'glyphicon ' + props.icon}/>
                </Link>
            }
        }
        else if (props.href !== undefined)
        {
            if ( component !== undefined )
            {
                const IconWrapper = component;

                return <a ref={setTriggerRef} href={props.href} target={props.target}><IconWrapper onClick={props.onClick} color={props.color}/></a>
            }
            else
            {
                return <a href={props.href} target={props.target}><span ref={setTriggerRef} style={{...defaultStyle, ...props.style, cursor: 'pointer', color: props.color}}
                                                                        className={'glyphicon ' + props.icon}/></a>
            }
        }
        else if (props.onClick !== undefined)
        {
            if (component !== undefined)
            {
                const IconWrapper = component;

                const divStyle = {...defaultStyle, display: 'inline-block', cursor: 'pointer'};

                return <div ref={setTriggerRef} style={divStyle} ><IconWrapper onClick={props.onClick} color={props.color}/></div>
            }
            else
            {
                return <span onClick={props.onClick} ref={setTriggerRef} style={{...defaultStyle, ...props.style, cursor: 'pointer', color: props.color}}
                         className={'glyphicon ' + props.icon}/>
            }
        }
        else
        {
            if (component !== undefined)
            {
                const IconWrapper = component;

                const divStyle = {...defaultStyle, display: 'inline-block', cursor: 'pointer'};

                return <div ref={setTriggerRef} style={divStyle} ><IconWrapper color={props.color}/></div>
            }
            else
                return <span ref={setTriggerRef} style={{...defaultStyle, ...props.style, color: props.color}}
                         className={'glyphicon ' + props.icon}/>
        }
    }

    return (
        <Fragment>
            { renderComponent() }
            {visible && (
                <div ref={setTooltipRef} {...getTooltipProps({className: containerClassName})}>
                    {props.text}
                <div {...getArrowProps({className: arrowClassName})} />
                </div>
            )}
        </Fragment>
    )
}


export default TooltipIcon;
